import classNames from "classnames";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useField } from "formik";
import { useTranslation } from "react-i18next";

import AddCard from "@components/AddCard";
import TextTooltip from "@components/TextTooltip";
import SelectCardDropdown from "@components/SelectCardDropdown";

import { maxCardsCount } from "@const/payments";

import { ReactComponent as IconAdd } from "@assets/ic-add.svg";

import styles from "./index.module.scss";

const SelectCardForm = ({
  postId,
  amount,
  message,
  userId,
  isAddCardOpen,
  setIsAddCardOpen,
}) => {
  const { t } = useTranslation("buttons");
  const { t: t1 } = useTranslation("chat");
  const { t: t2 } = useTranslation("modals");
  const { t: t3 } = useTranslation("errors");

  const [, { error }] = useField({
    name: "cardId",
    type: "text",
  });

  const {
    allCards,
    isLoading: isCardsLoading,
    isAdding,
  } = useSelector(({ cardsReducer }) => cardsReducer);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const toggleAddCardModal = () => {
    setIsAddCardOpen(!isAddCardOpen);
  };

  const maxCardsAdded = allCards.length >= maxCardsCount;

  const renderButton = () => (
    <span
      className={classNames(
        "text-medium cursor-pointer d-flex align-items-center add-card-btn",
        maxCardsAdded && "pointer-events-none",
      )}
      onClick={toggleAddCardModal}
    >
      <IconAdd width={20} height={20} className="me-2" />
      {t("ADD_NEW_CARD")}
    </span>
  );

  return (
    <>
      <AddCard
        isOpen={isAddCardOpen}
        toggle={toggleAddCardModal}
        isAdding={isAdding}
        isModal
      />
      <SelectCardDropdown
        allCards={allCards}
        isCardsLoading={isCardsLoading}
        onCardIdChange={() => {}}
        isDropDownOpen={isDropDownOpen}
        setIsDropDownOpen={setIsDropDownOpen}
        name="cardId"
        message={message}
        amount={amount}
        postId={postId}
        userId={userId}
        wrapperClassname="mb-3"
      />
      {allCards.length === 0 && (
        <span
          className={classNames(
            styles.noCardsPlaceholder,
            "text-primary text-body-1 d-block",
          )}
        >
          {t1("NO_CARDS_PLACEHOLDER")}
        </span>
      )}
      {maxCardsAdded ? (
        <TextTooltip
          wrapperClassName="d-flex text-primary"
          text={t2("FIVE_CARDS_MAX_TOOLTIP")}
        >
          {renderButton()}
        </TextTooltip>
      ) : (
        renderButton()
      )}
      <div className="position-relative">
        {error && (
          <span
            className={classNames(
              "text-danger text-body-2 position-absolute",
              styles.error,
            )}
          >
            {t3(error)}
          </span>
        )}
      </div>
    </>
  );
};

export default SelectCardForm;
